import { platformMap } from "../data/platforms";
import { formatRelativeTime } from "../lib/format";
import type { AggregateItem } from "../types";
import { Icon } from "./Icon";

interface AggregateBoardProps {
  items: AggregateItem[];
  loading: boolean;
  onOpen: (item: AggregateItem) => void;
}

export function AggregateBoard({ items, loading, onOpen }: AggregateBoardProps) {
  return (
    <section className="aggregate-board" aria-labelledby="aggregate-title">
      <header className="section-heading aggregate-heading">
        <div>
          <span className="section-index">01</span>
          <div>
            <h1 id="aggregate-title">跨平台总榜</h1>
            <p>相同热点合并计算，多平台同时出现时排名更高</p>
          </div>
        </div>
        <span className="aggregate-rule">全网 · 当前</span>
      </header>

      {loading ? (
        <div className="aggregate-grid" aria-label="正在加载跨平台总榜">
          {Array.from({ length: 6 }, (_, index) => <div className="aggregate-skeleton" key={index} />)}
        </div>
      ) : items.length ? (
        <ol className="aggregate-grid">
          {items.slice(0, 8).map((item, index) => (
            <li key={item.id}>
              <button className="aggregate-item" onClick={() => onOpen(item)} type="button">
                <span className="aggregate-rank">{String(index + 1).padStart(2, "0")}</span>
                <span className="aggregate-copy">
                  <strong>{item.title}</strong>
                  <span>
                    {item.sources.slice(0, 3).map((source) => platformMap.get(source.platformId)?.name).filter(Boolean).join(" · ")}
                    {item.sourceCount > 3 ? ` 等 ${item.sourceCount} 个平台` : ` · ${item.sourceCount} 个平台`}
                  </span>
                </span>
                <Icon name="external" />
              </button>
            </li>
          ))}
        </ol>
      ) : (
        <div className="aggregate-empty">
          <span className="aggregate-rank">00</span>
          <div>
            <strong>等待首次数据采集</strong>
            <p>公开数据源恢复后，轻量接口会自动生成总榜。</p>
          </div>
        </div>
      )}

      {items[0]?.updatedAt ? <p className="aggregate-time">榜单{formatRelativeTime(items[0].updatedAt)}</p> : null}
    </section>
  );
}
